import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { Popup } from 'es6/libs/popup'
import { positionLeftOfOpener } from 'helpers/popup-positioning-helper'
import { getTemplate } from 'helpers/template-helper'
import Backbone from 'init/backbone'
import get from 'lodash/get'

/**
 * Попап с псевдофильтрами по категорям.
 */
@Defaults({
  events: {
    'click .js-category-filter': 'sendEventToApplyFilter',
  },
  additionalOptions: ['filters'],
})
export class CategoriesFilterPopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate('#category-filter-list-template')
    this.popup = new Popup(this.$el)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      (jqEvent, { target }) => {
        this.onBeforeOpenPopup(target)
      }
    )
  }

  /**
   * Выполняется перед открытием попапа
   * @param {jQuery} $opener - элемент инициатора открытия попапа
   */
  onBeforeOpenPopup ($opener) {
    this.$el.css(positionLeftOfOpener($opener, this.$el))
    super.render({
      categoryFilters: get(this.filters, 'data.category.values', []),
    })
  }

  /**
   * Триггерит событие через Backbone для применения фильтра
   * @param {Event} event - событие клика по кнопке фильтра
   */
  sendEventToApplyFilter (event) {
    this.popup.close()
    if (!event.currentTarget.classList.contains('selected')) {
      Backbone.trigger('toggle-check-all-categories')
      Backbone.trigger('backbone-filter-apply', event)
    }
  }
}
